import {FC, MouseEvent, useEffect, useState} from 'react'

interface Props {
    product: any
    booking: Booking,
    setBooking: Function
}

const Product: FC<Props> = ({product, booking, setBooking}) => {

    const closeTooltip = (event: MouseEvent) => {
        event.currentTarget.parentElement.classList.add("wco-info-tooltip--hidden")
        event.preventDefault()
        event.stopPropagation()
    }

    const openTooltip = (event: MouseEvent) => {
        const collection = document.getElementsByClassName("wco-info-tooltip--hidden");
        for (let i = 0; i < collection.length; i++) {
            collection[i].classList.remove("wco-info-tooltip--hidden");
        }
        event.preventDefault()
        event.stopPropagation()
    }

    const handleClick = (product:any, event: MouseEvent) => {
        // Update "Cart"
        const clickedIndex = booking.options.findIndex(option => option.id === product.id)
        if(clickedIndex > -1) {
            // Remove from cart
            booking.options.splice(clickedIndex, 1);
        }else{
            // Add to cart
            if(product.select_attr === 'single_select') {
                // Check category, only one item allowed in cart
                for(let i=0; i<booking.options.length; i++){
                    if(booking.options[i].category === product.category) {
                        booking.modal = 1
                    }
                }
            }

            if(booking.modal === 0) {
                booking.options.push(product)
            }
        }
        setBooking({
            ...booking,
        })
    }

    // Mark selected option
    let optionIds:any = []
    booking.options.map((option, i:number) => (
        optionIds.push(option.id)
    ))
    const className = optionIds.includes(product.id) ? 'option checked' : 'option'

    // Price and sale badge
    let price = <span className="product-price"><bdi>{product.price}</bdi> kr</span>
    let sale_flash = <></>
    if(product.is_on_sale) {
        sale_flash = <div className={'on-sale'}>Kampanj {product.price_string}</div>
        price = <span className="product-price">
                    <del aria-hidden="true"><bdi>{product.price}</bdi> kr</del>
                    <span className={'sale'}><bdi>{product.sale_price}</bdi> kr</span>
                </span>
    }
    if(!product.is_price_visible)
        price = <span className="product-price">Pris offereras på mail efter bokning</span>

    return (
        <div className={className}>
            <div className={"option__main"}>
                <div className={'option__image'}>
                    <img src={product.image} alt={product.name}/>
                </div>
                <div className={'option__name'}>
                    {sale_flash}
                    <div>{product.name}</div>
                    <div className={'option__price'}>{price}</div>
                    {product.info && (
                        <div className="wco-info" onMouseDown={(event) => openTooltip(event)}>
                            <i className="far fa-info-circle" aria-hidden="true" />
                            <div className="wco-info-tooltip">
                                <div className="wco-info-tooltip__close" onMouseDown={(event) => closeTooltip(event)}>
                                    <i className="popup_close far fa-times-circle" aria-hidden="true"></i>
                                </div>
                                <div className="wco-info__content" dangerouslySetInnerHTML={{__html: product.info}} />
                            </div>
                        </div>
                    )}
                </div>
                <div className={"btn btn--skyblue btn-service__action"} onMouseDown={(event) => handleClick(product, event)}>
                    {className === 'option' ? 'Välj' : 'Vald'}
                </div>
            </div>
        </div>
    )
};

export default Product
